"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Credits = _interopRequireDefault(require("../Credits"));

var _KeyGen = require("@healthwise-ui/core/KeyGen");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.8em;\n  margin: 5px 2px 0;\n  padding: 10px 15px;\n  color: #017acd;\n  border: none;\n  background: transparent;\n  border-radius: 1px;\n\n  &:focus, \n  &:hover {\n    outline: 2px dotted #000;\n  }\n\n  padding: 5px 15px;\n  &:disabled {\n    padding: 0;\n  }\n  \n  &:disabled:focus,\n  &:disabled:hover {\n    outline: none;\n    cursor: default;\n  }\n  \n\n  @media screen and (-ms-high-contrast: active) {\n    background: #fff;\n    color: #000;\n  }\n\n  @media screen and (-ms-high-contrast: black-on-white) {\n    background: #000;\n    color: #fff;\n    outline: 2px dotted #fff;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 18px;\n  margin-right: 4px;\n\n  & svg {\n    width: 100%;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  justify-content: space-between;\n\n  @media screen and (-ms-high-contrast: active) {\n    background: #fff;\n    color: #000;\n  }\n\n  @media screen and (-ms-high-contrast: black-on-white) {\n    background: #000;\n    color: #fff;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 24px;\n  box-sizing: border-box;\n  width: 100%;\n\n  & p {\n    font-size: 0.8em;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DivWrapper = _styledComponents.default.div(_templateObject());

var DivNavWrapper = _styledComponents.default.div(_templateObject2());

var NavButtonsRow = _styledComponents.default.div(_templateObject3());

var IconSpan = _styledComponents.default.span(_templateObject4());

var NavRightWrapper = _styledComponents.default.div(_templateObject5());

var NavButton = _styledComponents.default.button(_templateObject6());

var MediaCredits = /*#__PURE__*/function (_Component) {
  _inherits(MediaCredits, _Component);

  var _super = _createSuper(MediaCredits);

  function MediaCredits(props) {
    var _this;

    _classCallCheck(this, MediaCredits);

    _this = _super.call(this, props);
    _this.toggleDisclaimer = _this.toggleDisclaimer.bind(_assertThisInitialized(_this));
    _this.toggleCredits = _this.toggleCredits.bind(_assertThisInitialized(_this));
    _this.toggleTranscript = _this.toggleTranscript.bind(_assertThisInitialized(_this));
    _this.renderDisclaimer = _this.renderDisclaimer.bind(_assertThisInitialized(_this));
    _this.renderCredits = _this.renderCredits.bind(_assertThisInitialized(_this));
    _this.renderTranscript = _this.renderTranscript.bind(_assertThisInitialized(_this)); // set up component state so we can retain the selected thumbnail

    _this.state = {
      showDisclaimer: false,
      showCredits: false,
      showTranscript: false
    };
    return _this;
  }

  _createClass(MediaCredits, [{
    key: "toggleDisclaimer",
    value: function toggleDisclaimer() {
      var newState = !this.state.showDisclaimer;
      this.setState({
        showDisclaimer: newState,
        showCredits: false,
        showTranscript: false
      });
    }
  }, {
    key: "toggleCredits",
    value: function toggleCredits() {
      var newState = !this.state.showCredits;
      this.setState({
        showDisclaimer: false,
        showCredits: newState,
        showTranscript: false
      });
    }
  }, {
    key: "toggleTranscript",
    value: function toggleTranscript() {
      var newState = !this.state.showTranscript;
      this.setState({
        showDisclaimer: false,
        showCredits: false,
        showTranscript: newState
      });
    }
  }, {
    key: "renderTranscript",
    value: function renderTranscript(html, id) {
      return this.state.showTranscript ? /*#__PURE__*/_react.default.createElement("div", {
        role: "region",
        "aria-live": "polite",
        "aria-atomic": "false",
        className: "hw-media-credits-transcript",
        id: id,
        dangerouslySetInnerHTML: {
          __html: html
        }
      }) : null;
    }
  }, {
    key: "renderDisclaimer",
    value: function renderDisclaimer(text, id) {
      return this.state.showDisclaimer ? /*#__PURE__*/_react.default.createElement("p", {
        role: "region",
        id: id,
        "aria-live": "polite"
      }, text) : null;
    }
  }, {
    key: "renderCredits",
    value: function renderCredits(id) {
      var _this$props = this.props,
          asOfDate = _this$props.asOfDate,
          credits = _this$props.credits;
      return this.state.showCredits ? /*#__PURE__*/_react.default.createElement(_Credits.default, {
        role: "region",
        id: id,
        "aria-live": "polite",
        "aria-atomic": "false",
        asOfDate: asOfDate,
        credits: credits
      }) : '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          legal = _this$props2.legal,
          hideDisclaimer = _this$props2.hideDisclaimer,
          transcriptHtml = _this$props2.transcriptHtml;
      var creditsId = (0, _KeyGen.getKey)();

      var creditsButton = /*#__PURE__*/_react.default.createElement(NavButton, {
        "aria-controls": creditsId,
        type: "button",
        onClick: this.toggleCredits,
        "aria-expanded": this.state.showCredits
      }, "Credits");

      var disclaimerId = (0, _KeyGen.getKey)();
      var disclaimerElement = hideDisclaimer ? null : this.renderDisclaimer(legal.disclaimerText, disclaimerId); // if hideDisclaimer prop was true, disclaimerElement will be null therefore no button

      var disclaimerButton = disclaimerElement ? /*#__PURE__*/_react.default.createElement(NavButton, {
        "aria-controls": disclaimerId,
        type: "button",
        onClick: this.toggleDisclaimer,
        "aria-expanded": this.state.showDisclaimer
      }, "Disclaimer") : '';
      var transcriptId = (0, _KeyGen.getKey)();
      var transcriptElement = transcriptHtml ? this.renderTranscript(transcriptHtml, transcriptId) : null;
      var transcriptButton = transcriptHtml ? /*#__PURE__*/_react.default.createElement(NavButton, {
        "aria-controls": transcriptId,
        type: "button",
        onClick: this.toggleTranscript,
        "aria-expanded": this.state.showTranscript
      }, /*#__PURE__*/_react.default.createElement(IconSpan, null, /*#__PURE__*/_react.default.createElement("svg", {
        role: "presentation",
        focusable: "false",
        width: "18",
        height: "22",
        viewBox: "0 0 18 22",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
        d: "M1.528 1.634h14.944v18.732H1.528V1.634z",
        fill: "#017acd"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M3.728 9.646h10.59v2.26H3.728v-2.26zm0-4.355h10.59v2.26H3.728V5.29zm-.073 9.036h6.403v2.404H3.655v-2.404z",
        fill: "#fff"
      })))), /*#__PURE__*/_react.default.createElement("span", null, "Transcript")) : /*#__PURE__*/_react.default.createElement(NavButton, {
        tabIndex: "-1",
        disabled: true,
        type: "button",
        role: "presentation",
        "aria-hidden": "true"
      }, ' ');
      return /*#__PURE__*/_react.default.createElement(DivWrapper, null, /*#__PURE__*/_react.default.createElement(DivNavWrapper, null, /*#__PURE__*/_react.default.createElement(NavButtonsRow, null, transcriptButton, /*#__PURE__*/_react.default.createElement(NavRightWrapper, null, disclaimerButton, creditsButton))), transcriptElement, disclaimerElement, this.renderCredits(creditsId));
    }
  }]);

  return MediaCredits;
}(_react.Component);

MediaCredits.defaultProps = {
  credits: {},
  legal: {
    disclaimerText: '*** Missing disclaimer ***'
  },
  hideDisclaimer: false
};
MediaCredits.propTypes = {
  asOfDate: _propTypes.default.string,
  transcriptHtml: _propTypes.default.string,
  legal: _propTypes.default.shape({
    disclaimerText: _propTypes.default.string.isRequired
  }),
  credits: _propTypes.default.object,
  hideDisclaimer: _propTypes.default.bool
};
var _default = MediaCredits;
exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/content/MediaCredits/index.js